/**
 * @description Component to search expenses
 * @param {string} searchAnExpense - The current search term entered by the user.
 * @param {function} onSearchChange - The function to handle the search change
 * @returns {JSX.Element} - The input to search expenses
 */

import { TextInput } from "flowbite-react";
import { Search } from "lucide-react";

type ExpenseSearchProps = {
  searchAnExpense: string
  onSearchChange: (searchTerm: string) => void
};

export const ExpenseSearch = ({ searchAnExpense, onSearchChange }: ExpenseSearchProps) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value);
  };

  return (
    <TextInput
      id="search"
      type="text"
      className="form-control w-full"
      placeholder="Rechercher par date, marchand ..."
      value={searchAnExpense}
      icon={Search}
      onChange={handleSearchChange}
    />
  );
};
